<div [class.skip-link-focused]="isSkipLinkFocused()" class="navbar-container">
  <button mobileOnly (click)="menu.toggleMenu()" class="menu-button" [attr.aria-expanded]="!menu.menuHidden" aria-haspopup="true">
    <svg-icon src="assets/images/icons/menu.svg" class="menu-icon"></svg-icon>
    <span class="menu-text">Menü</span>
  </button>

  <a class="logo" routerLink="/" aria-label="Startseite">
    <svg-icon src="assets/images/icons/logo.svg" class="symbox-logo" />
  </a>

  <button mobileOnly (click)="togglePhoneNumber()" class="contact" [attr.aria-expanded]="showPhoneNumber" aria-haspopup="true">
    <svg-icon src="assets/images/icons/phone.svg" class="hotline-icon"></svg-icon>
    <p>Kontakt</p>
  </button>

  <div desktopOnly class="navigation-container">
    <nav aria-label="Desktop Navigation" class="navigation-items">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"> Startseite </a>
      <a routerLink="/downloads" routerLinkActive="active"> Downloads </a>
      <a routerLink="/kontakt" routerLinkActive="active"> Kontakt </a>
    </nav>

    <a href="tel:0800-103-0010" class="hotline-button">
      <svg-icon src="assets/images/icons/phone.svg" class="hotline-icon"></svg-icon>
      <div class="hotline-text">
        <p class="text">Kostenlose Hotline</p>
        <p class="number">0800-103-0010</p>
      </div>
    </a>
  </div>

  <div
    mobileOnly
    class="phone-number-container"
    [class.show-number]="showPhoneNumber"
    [attr.inert]="showPhoneNumber ? null : 'true'"
    role="dialog"
    aria-modal="true"
    aria-label="Hotline Number"
    #phoneNumberContainer>
    <a href="tel:0800-103-0010" class="phone-number" #phoneNumberLink>
      <p class="text">Kostenlose Hotline</p>
      <p class="number">0800-103-0010</p>
    </a>
  </div>
</div>
